module.exports = __webpack_public_path__ + "img/blog-07.a8e719de.jpg";